module.exports = __webpack_public_path__ + "videos/freehand-en.8981764.mp4";